import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, LinearProgress, Stack, Typography } from '@mui/material';
import { API } from '../../services/amplifyCompat';
import { getAllValidatedSubmittedActionsInGroup } from '../../graphql/queries';
import SubmittedActionCard from '../SubmittedActionCard';

import useTranslation from '../customHooks/translations';

const MemberActionsPanel = ({ groupInfo, cognitoUser }) => {
  const translation = useTranslation();
  const [actions, setActions] = useState();
  const [showMore, setShowMore] = useState(false);
  const [error, setError] = useState(false);

  const getActions = async () => {
    setError(false);
    try {
      const res = await API.graphql({
        query: getAllValidatedSubmittedActionsInGroup,
        variables: { group_id: groupInfo.group_id },
      });
      setActions(res.data.getAllValidatedSubmittedActionsInGroup ?? []);
    } catch {
      setActions([]);
      setError(true);
    }
  };

  useEffect(() => {
    getActions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderActionCards = () => {
    if (actions) {
      return showMore
        ? actions.map((action) => (
            <SubmittedActionCard
              key={action.sa_id}
              action={action}
              showUnapproveButton={
                cognitoUser.attributes['custom:type'] === 'Admin'
              }
              getActions={getActions}
            />
          ))
        : actions
            .slice(0, 3)
            .map((action) => (
              <SubmittedActionCard
                key={action.sa_id}
                action={action}
                showUnapproveButton={
                  cognitoUser.attributes['custom:type'] === 'Admin'
                }
                getActions={getActions}
              />
            ));
    }
  };

  return (
    <Box sx={{ overflow: 'auto', padding: '0.25em', mt: '1.5em' }}>
      <Stack spacing={2}>
        {renderActionCards()}
        {!actions ? (
          <LinearProgress />
        ) : error ? (
          <Alert severity="error">
            {translation.createStudentAccount?.unexpectedError ||
              'An unexpected error occurred. Please try again later.'}
          </Alert>
        ) : actions.length > 3 ? (
          <Button
            sx={{ mt: '3em' }}
            variant="outlined"
            onClick={() => setShowMore(!showMore)}
          >
            {translation.view} {showMore ? translation.less : translation.more}
          </Button>
        ) : actions.length === 0 ? (
          <Typography variant="subtitle2">
            {translation.noActions}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
};

export default MemberActionsPanel;
